import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  vanBanId: 1,
  vanBanDangCapNhat: {},
  danhSachVanBan: [
    {
      id: 1,
      title: "văn bản 1",
      description: "Mô tả văn bản 1",
    },
  ],
  danhSachDonViNgoai: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
